import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { forwardRef } from 'react';
import { Button } from '../../atoms/Button/Button';
import { Stack } from '../../atoms/Stack/Stack';
import { Typography } from '../../atoms/Typography/Typography';
import { IconList } from '../../molecules/IconList/IconList';
export const MediaCard = forwardRef(function HorizontalMediaCard({ id, title, bulletPoints, image, imageAlt, buttonLabel, handleClick, cardWidth = 280, }, ref) {
    return (_jsxs(Card, { sx: {
            maxWidth: cardWidth,
            minWidth: cardWidth,
            marginBottom: (theme) => theme.spacing(106),
            paddingBottom: (theme) => theme.spacing(102),
            boxShadow: 'none',
            border: (theme) => `1px solid ${theme.palette.grey['900']}`,
            justifyContent: 'space-between',
            flexDirection: 'column',
            display: 'flex',
            ':hover': {
                boxShadow: (theme) => theme.shadows[10],
            },
        }, ref: ref, children: [_jsxs(Stack, { children: [_jsx(CardMedia, { sx: { height: 140 }, image: image, title: imageAlt }), _jsx(CardContent, { sx: {
                            padding: (theme) => theme.spacing(3),
                        }, children: _jsxs(Stack, { gap: 104, children: [_jsx(Box, { children: _jsx(Typography, { variant: "body1 semibold", children: title }) }), _jsx(Stack, { gap: 102, children: bulletPoints.length > 0 &&
                                        bulletPoints.map((bulletPoint) => {
                                            return (_jsx(IconList, { text: bulletPoint, iconVariant: "check", iconSize: "small", textVariant: "body2 light" }, bulletPoint));
                                        }) })] }) })] }), _jsx(CardActions, { sx: {
                    paddingBottom: (theme) => theme.spacing(2),
                    justifyContent: 'center',
                }, children: _jsx(Button, { size: "small", onClick: () => {
                        handleClick(id);
                    }, children: buttonLabel }) })] }));
});
